export default __webpack_public_path__ + "static/media/_northern-cyprus.51438bf1.ico";